import { z } from 'zod/v4';

import { normalizeNavigationWidgetArgs } from './navigation-widget-args.normalization';
import { partialNavigationWidgetDataSchema } from './partial-navigation-widget-data.schema';

const updateNavigationWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the navigation widget to update.'),
    data: partialNavigationWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed, everything else is left as-is. ' +
            '"menuList", if provided, replaces the whole list.'
    ),
});

export const updateNavigationWidgetArgsSchema = z.preprocess(
    normalizeNavigationWidgetArgs,
    updateNavigationWidgetObjectSchema
);
